import { useMemo } from 'react';

import { useAuth } from '../auth/AuthProvider';
import { decodeJwt, isSuperuserFromClaims } from '../lib/jwt';

/**
 * Platform superuser: the Keycloak `superuser` realm role (provisioned by
 * `keycloak-init-formant-realm.sh`) OR a Robotics token's
 * `formant:claims.isSuperuser`. Superuser routes (/internal/*) read this to
 * decide whether to render or redirect home.
 */
export function useIsSuperuser(): boolean {
  const { token } = useAuth();
  return useMemo(() => isSuperuserFromClaims(decodeJwt(token)), [token]);
}
